const define = {
    "buttonText.discoverDefineClassic": "了解經典/璀璨系列",
    "buttonText.discoverDefineFresh": "了解花眸/甜漾系列",
    "buttonText.findStores": "立即查詢",
    "buttonText.learnMore": "了解更多",
    "buttonText.shopNow": "門市查詢",
    "buttonText.tryTheVirtualMirror": "立即試戴",
    "features.paragraph1.title": "美學工藝",
    "features.paragraph1.description": "融合科學研究與精緻手繪花紋工藝，打造與天然瞳色完美融合的隱形眼鏡，自然的放大效果，展現令人一眼著迷的自信魅力！",
    "features.paragraph2.title": "舒適安心雙科技",
    "features.paragraph2.description": "- LACREON® 水凝科技，將保濕因子 20 小時鎖在鏡片中，維持雙眼全日配戴水潤舒適。</br>- BWIC™ 透氧隔色科技，鏡片隔離色素不直接接觸眼睛，且色圈不降低透氧率，讓雙眼自在呼吸。",
    "features.paragraph3.title": "第二級 UV 防護",
    "features.paragraph3.freshdescription": "平均阻隔 81% UVA 及 97% UVB，減少紫外線對眼睛的傷害。",
    "features.paragraph3.classicdescription": "平均阻隔 81% UVA 及 97% UVB，減少紫外線對眼睛的傷害。",
    "headline.classic.description": "閃耀天生魅力，以創新工藝打造的自然大地色系，以環狀色圈為特色，彰顯大膽風格。",
    "headline.classic.title": "睛漾水凝® 經典/璀璨系列",
    "headline.fresh.description": "延續品牌一貫「自然、科學、藝術」的極致工藝，花眸/甜漾系列提供令人驚豔的新色，極致細膩花紋，迷人出色，綻放花漾明眸魅力。",
    "headline.fresh.title": "睛漾水凝® 花眸/甜漾系列",
    "lensWear.howToPut": "如何配戴及取下隱形眼鏡",
    "lensWear.insert1.description": "徹底清潔及擦乾雙手，再開始戴隱形眼鏡。",
    "lensWear.insert1.title": "確保手部清潔",
    "lensWear.insert2.description": "先以食指指腹取出隱形眼鏡，放在食指指尖。正面的鏡片邊緣應像碗公形狀。如果邊緣朝外翻，代表隱形眼鏡為反面，只需翻轉隱形眼鏡即可。",
    "lensWear.insert2.title": "辨別正反面",
    "lensWear.insert3.description": "以兩隻中指拉開上下眼皮，並確保不會被睫毛擋住。",
    "lensWear.insert3.title": "拉開上下眼皮",
    "lensWear.insert4.description": "用食指將隱形眼鏡放上眼珠，並輕閉雙眼讓鏡片自然定位。",
    "lensWear.insert4.title": "完成配戴",
    "lensWear.insertion": "如何配戴",
    "lensWear.removal": "如何取下",
    "lensWear.remove1.description": "確保手部清潔，然後往上看，並用中指輕輕拉下眼皮。",
    "lensWear.remove1.title": "輕輕拉下眼皮",
    "lensWear.remove2.description": "慢慢將食指移至眼睛附近，直到觸及隱形眼鏡的下緣，然後將隱形眼鏡往下滑動至下眼白。",
    "lensWear.remove2.title": "下移隱形眼鏡",
    "lensWear.remove3.description": "用拇指與食指的指腹呈 V 字型，兩指合攏以指腹將鏡片輕輕捏下。*切勿使用指甲捏下 ",
    "lensWear.remove3.title": "取下鏡片",
    "lensWear.remove4.description": "睛漾水凝®為日拋式隱形眼鏡，適用於一次性配戴，使用後應立即丟棄。",
    "lensWear.remove4.title": "丟棄",
    "lensWear.title": "配戴方法",
    "references.content": "<p>下載完整產品仿單-衛署醫器輸字第021286號<a href='https://lmspiq.fda.gov.tw/web/MDPIQ/MDPIQ1000Result?licBaseId=1A21DD91-586B-434F-94CB-0C26B4CD0682'>https://lmspiq.fda.gov.tw/web/MDPIQ/MDPIQ1000Result?licBaseId=1A21DD91-586B-434F-94CB-0C26B4CD0682</a></br></br>下載完整產品仿單-衛部醫器輸字第035047號 <a href='https://lmspiq.fda.gov.tw/web/MDPIQ/MDPIQ1000Result?licBaseId=A2E1C0C2-E644-443E-89D6-2823E6F0B2A3'>https://lmspiq.fda.gov.tw/web/MDPIQ/MDPIQ1000Result?licBaseId=A2E1C0C2-E644-443E-89D6-2823E6F0B2A3</a>",
    "related.discover": "了解更多",

    "showNow.title": "門市查詢",
    "showNow.description": "即刻上網選購，享有安視優®產品獨家優惠",
    "showNow.physical.details": "搜尋離您最近的安視優®銷售據點",

    "specs.additionalInfo": "更多資訊",
    "specs.baseCurve": "鏡片弧度(基弧)",
    "specs.baseCurve.detail": "8.5mm",
    "specs.centre": "鏡片直徑/著色直徑",
    "specs.centre.fresh.detail": "14.2 mm / 13.0 mm",
    "specs.centre.classic.detail": "14.2 mm / 12.5 ~ 13.0 mm",
    "specs.internal": "保濕原理",
    "specs.internal.detail": "LACREON®水凝科技，將 PVP 保濕因子 (Polyvinylpyrrolidone) 20小時鎖在鏡片中不隨時間或眨眼流失",
    "specs.material": "鏡片材質",
    "specs.material.detail": "Etafilcon A 水膠",
    "specs.oxygen": "透氧量",
    "specs.oxygen.detail": "33.3 x 10<span>−9</span> (屏障校正 @ -3.00D)",
    "specs.packageSize": "包裝方式",
    "specs.packageSize.fresh.detail": "10片裝",
    "specs.packageSize.classic.detail": "10片裝&30片裝",
    "specs.freshpowerRange": "度數",
    "specs.classicpowerRange": "度數",
    "specs.freshpowerRange.detail": "無近視 0.00<br />近視 -0.50 ~ -6.00 (每 25 度一級)<br />近視 -6.50 ~ -9.00 (每 50 度一級)",
    "specs.classicpowerRange.detail": "無近視 0.00<br />近視 -0.50 ~ -6.00 (每 25 度一級)<br />近視 -6.50 ~ -9.00 (每 50 度一級)",
    "specs.specifications": "產品規格",
    "specs.water": "含水量",
    "specs.water.detail": "58%"
}

const download_now = {
  "download_now.title": "新會員馬上領 $100 購物金",
  "download_now.p": "立即加入 MyACUVUE® ，享有專屬您的安視優®會員獨家優惠！",
  "download_now.button": "了解更多",
}

// export default define;
export default {
  ...define,
  ...download_now
};
